if (!customElements.get("announcement-bar")) customElements.define("announcement-bar", class AnnouncementBar extends HTMLElement {
    #STORAGE_KEY="MBF_announcement_closed";
    #EXPIRY_MS=12096e5;
    #onCountdownExpired=null;
    connectedCallback() {
        if (this.#isClosed()) {
            this.#hide();
            return;
        }
        this.#onCountdownExpired = () => {
            if (!this.textContent.trim()) this.#hide();
        };
        document.addEventListener("countdown:expired", this.#onCountdownExpired);
        const closeBtn = this.querySelector("[data-close]");
        if (closeBtn) closeBtn.addEventListener("click", () => this.#closeBanner(), {
            once: true
        });
    }
    disconnectedCallback() {
        if (this.#onCountdownExpired) document.removeEventListener("countdown:expired", this.#onCountdownExpired);
    }
    #hide() {
        this.style.display = "none";
        window.dispatchEvent(new CustomEvent("layout:change"));
    }
    #isClosed() {
        try {
            const value = localStorage.getItem(this.#STORAGE_KEY);
            if (!value) return false;
            return Date.now() - Number(value) < this.#EXPIRY_MS;
        } catch (e) {
            return false;
        }
    }
    #closeBanner() {
        this.#hide();
        try {
            localStorage.setItem(this.#STORAGE_KEY, Date.now().toString());
        } catch (e) {}
    }
});